import React, { useEffect, useState } from "react";
import { Modal, Button, Row, Col } from "react-bootstrap";
import DataTable from "react-data-table-component";
import { useDispatch, useSelector } from "react-redux";
import Constants from "../../../../common/SupplierConstants";
import { getEstimationList, setEstimationData } from "../../../../redux/feature/customer_app/customerV1Slice";

const EstimationMatchModal = React.forwardRef((props, ref) => {
  const dispatch = useDispatch();

  const estimationData = useSelector(
    (state) => state.customerV1.estimationDraft.estimationData
  );
  let estData = useSelector((state) => state?.customerV1?.estimation || []);
  
  const [getSelectedData, setSelectedData] = useState(null)
  const [selectedBuilding, setSelectedBuilding] = useState(null);

  // console.log(">>getSelectedData",getSelectedData)
  // console.log(">>selectedBuilding",selectedBuilding)
const selectedRows = (buidlding) =>{
setSelectedData(buidlding)
}

  let estimationTable = useSelector(
    (state) => state?.customerV1?.estimation?.pagination
  );


  const estimationCol = [
    {
      name: "Estimation Nr",
      id: "documentNumber",
      selector: (row) => row?.documentNumber,
      cell: (row) => (
        <>
          {row?.headerStatus === "Estimation Draft" ? (
            <button
              className="btnInfo "
              // onClick={() => estimationDisplay(row?.estimationNr)}
            >
              {/* <span className="d-block text-nowrap">Modify</span> */}
              <span className="text-nowrap">{row?.documentNumber}</span>
            </button>
          ) : (
            <button
              className="btnInfo"
              // onClick={() => estimationDisplay(row?.estimationNr)}
            >
              {row?.documentNumber}
            </button>
          )}
        </>
      ),
      width: "120px",
    },
    {
      name: "Matching",
      // id: "version",
      selector: (row) => row?.filterCountBuildings,
      cell: (row) => (
        <>
          <button className="btnInfo" onClick={()=>selectedRows(row?.buildings)}>{row?.filterCountBuildings} Buildings</button>
        </>
      ),
      sortable: true,
      width: "120px",
    },
//     {
//   name: "%",
//   selector: (row) => row?.filterCountBuildings,
//   cell: (row) => {
//     // Generate the tooltip text by mapping through the buildings array
//     const areaTooltip = row?.buildings
//       ?.map((building, index) => {
//         const area = Number(building.totalArea || building.buildingArea || 0).toFixed(4);
//         return `Building ${index + 1}: ${area} Sqm`;
//       })
//       .join('\n'); // join with new line for formatting

//     return (
//       <>
//         <button 
//           className="btnInfo" 
//           onClick={() => selectedRows(row?.buildings)}
//           // Standard HTML tooltip
//           title={areaTooltip} 
//         >
//           {row?.filterCountBuildings} Buildings
//         </button>
//       </>
//     );
//   },
//   sortable: true,
//   width: "120px",
// },
// estimationMatchModel.js (Column Configuration Object)

{
  name: "%",
  selector: (row) => row?.filterCountBuildings, // Sorting
  
  cell: (row) => {
    const enteredArea = props.enteredArea || 0; 
    
    if (!row?.buildings || row.buildings.length === 0) {
      return <span>0%</span>;
    }

    const percentMatch = row.buildings.map((building) => {
      const dbArea = Number(building.totalArea || building.buildingArea || 0);
      
      if (!enteredArea || !dbArea) return 0; 
      const smaller = Math.min(enteredArea, dbArea);
      const larger = Math.max(enteredArea, dbArea);

      return ((smaller / larger) * 100).toFixed(2); 
    });

    const bestMatch = Math.max(...percentMatch);
    
    const areaTooltip = row.buildings
      .map((b, i) => {
        const dbArea = Number(b.totalArea || b.buildingArea || 0).toFixed(4);
        const p = percentMatch[i];
        
        return `Building ${i + 1}: ${dbArea} Sqm | Match: ${p}%`;
      })
      .join("\n"); // Each building's detail on a new line

    return (
      <button 
        className="btnInfo" 
        title={areaTooltip} // Shows the detailed breakdown on hover
        onClick={() => selectedRows(row.buildings)} 
      >
        {bestMatch}% {/* Display the highest match percentage */}
      </button>
    );
  },
  
  sortable: true,
  width: "120px",
},

    {
      name: "Job/Qtn Ref",
      id: "version",
      selector: (row) => row?.jobReferenceNr || row?.qtnReferenceNr,
      cell: (row) => (
        <>
          {row.jobReferenceNr ? (
            <span className="bg-table-status bg-table-success-status">
              {row.jobReferenceNr} {"(J)"}
            </span>
          ) : row.qtnReferenceNr ? (
            <span className="bg-table-status bg-table-warning-status">
              {row.qtnReferenceNr} {"(Q)"}
            </span>
          ) : (
            "-"
          )}
        </>
      ),
      sortable: true,
      width: "150px",
    },

    {
      name: "Client/Company",
      selector: (row) => row.companyName,
      id: "companyName",
      dropDown: true,
      cell: (row) => (
        <div>
          <p className="">{row.companyName}</p>
          <p className="fw-bold">{row.clientName}</p>
        </div>
      ),
      sortable: true,
      width: "160px",
    },
    {
      name: "Tonnage/Area",
      selector: (row) => row.grandTotalWeight,
      id: "grandTotalWeight",
      dropDown: true,
      cell: (row) => (
        <div>
          <p className="fw-bold text-primary">
            {(row?.grandTotalWeight
              ? row.grandTotalWeight.toFixed(3)
              : "0.000") + " Mt"}
          </p>
          <p className="fw-medium text-success">
            {row?.getOverallBuildingArea?.toFixed(3) + " SqFt"} 
          </p>
        </div>
      ),
      sortable: true,
      width: "160px",
    },
    {
      name: "Cost",
      selector: (row) => row.grandTotalPrice,
      id: "grandTotalPrice",
      dropDown: true,
      cell: (row) => (
        <div>
          <p className="fw-bold text-success">
            {row?.grandTotalPrice?.toFixed(3)} INR{" "}
          </p>
        </div>
      ),
      sortable: true,
      width: "160px",
    },

    {
      name: "Created By",
      selector: (row) => row.createdBy,
      cell: (row) => (
        <>
          <div>
            <p className="fw-bold">{row.createdBy}</p>
            <p className="d-block">{row.createdName}</p>
          </div>
        </>
      ),
      sortable: true,
      width: "160px",
    },

  ];
  // User Details from Store
   // eslint-disable-next-line
  const [data, setData] = useState();

  // console.log(">>estimationData", estimationData);
 // eslint-disable-next-line
  const [buildings, setBuildings] = useState([]);
   // eslint-disable-next-line
  const [activeBuildingId, setActiveBuildingId] = useState(1); // Track active tab

  const [isCardVisible1, setCardVisible1] = useState(true);
  const toggleCardVisibility1 = () => {
    setCardVisible1(!isCardVisible1);
  };
  useEffect(() => {
    setBuildings(estimationData?.buildings);
    setActiveBuildingId(estimationData?.activeBuildingId);
  }, [estimationData]);

  useEffect(() => {
    // console.log(">>props match", props);
    // setLoadData(props?.rowdatamodal);

    const handleEscapeKey = (event) => {
      if (event.key === "Escape" || event.keyCode === 27) {
        props.onHide();
      }
    };
    document.addEventListener("keydown", handleEscapeKey);
    return () => {
      document.removeEventListener("keydown", handleEscapeKey);
    };
  }, [props]);

  //table Data
  const [getNewPerPage, setNewPerPage] = useState(10);

  const loadQuotationData = async () => {
    setData(estData?.data);
  };

  useEffect(() => {
    loadQuotationData(); // fetch page 1 of users
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [estData]);
  //on page load
  useEffect(() => {
    let obj = {
      queryName: "Get_ESTIMATION_LIST",
      module: "",
      page: 1,
      per_page: estimationTable.total,
    };
    dispatch(getEstimationList(obj));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  const handlePerRowsChange = async (newPerPage, page) => {
    let obj = {
      queryName: "Get_ESTIMATION_LIST",
      module: "CUSTOMER",
      page: page,
      per_page: newPerPage,
    };
    setNewPerPage(newPerPage);
    dispatch(getEstimationList(obj));
    setData(estData?.data);
  };

  const handlePageChange = (page) => {
    let obj = {
      queryName: "Get_ESTIMATION_LIST",
      module: "CUSTOMER",
      page: page,
      per_page: getNewPerPage,
    };
    dispatch(getEstimationList(obj));
    setData(estData?.data);
  };


  const handleRowSelect = (state) => {
    const rows = state?.selectedRows || [];
 // eslint-disable-next-line
    const uniqueIds = [...new Set(rows.map((item) => item.documentNumber))];

  };
  //filter the data
  // const filterKey = {
  //   buildingTypes:
  //     estimationData?.buildings?.[estimationData?.activeBuildingId - 1]
  //       ?.buildingTypes,
  //   buildingTypesCode:
  //     estimationData?.buildings?.[estimationData?.activeBuildingId - 1]
  //       ?.buildingTypesCode,
  //   buildingStructure:
  //     estimationData?.buildings?.[estimationData?.activeBuildingId - 1]
  //       ?.buildingStructure,
  //   designLoad:
  //     estimationData?.buildings?.[estimationData?.activeBuildingId - 1]
  //       ?.designLoad,
  //   designStandards:
  //     estimationData?.buildings?.[estimationData?.activeBuildingId - 1]
  //       ?.designStandards,
  // };
  const filterKey = {
    msNumber: estimationData?.buildings?.[estimationData?.activeBuildingId - 1]?.msNumber,
    buildingStructure: estimationData?.buildings?.[estimationData?.activeBuildingId - 1]?.buildingStructure,
    buildingStructureCode: estimationData?.buildings?.[estimationData?.activeBuildingId - 1]?.buildingStructureCode,
    design: estimationData?.buildings?.[estimationData?.activeBuildingId - 1]?.design,
    designCode: estimationData?.buildings?.[estimationData?.activeBuildingId - 1]?.designCode,
    buildingTypes: estimationData?.buildings?.[estimationData?.activeBuildingId - 1]?.buildingTypes,
    buildingTypesCode: estimationData?.buildings?.[estimationData?.activeBuildingId - 1]?.buildingTypesCode,
    mainBuildingType: estimationData?.buildings?.[estimationData?.activeBuildingId - 1]?.mainBuildingType,
    mainBuildingTypeCode: estimationData?.buildings?.[estimationData?.activeBuildingId - 1]?.mainBuildingTypeCode,
    subBuildingType: estimationData?.buildings?.[estimationData?.activeBuildingId - 1]?.subBuildingType,
    subBuildingTypeCode: estimationData?.buildings?.[estimationData?.activeBuildingId - 1]?.subBuildingTypeCode,
    // Including existing design objects for deep comparison
    designLoad: estimationData?.buildings?.[estimationData?.activeBuildingId - 1]?.designLoad,
    designStandards: estimationData?.buildings?.[estimationData?.activeBuildingId - 1]?.designStandards,
  };
  // console.log(">>filterKey", filterKey);
  const isObjectEqual = (obj1, obj2) => {
    return JSON.stringify(obj1) === JSON.stringify(obj2);
  };

  const safeEstData = Array.isArray(estData)
    ? estData
    : estData?.data || estData?.estimation || [];
  const [filteredData, setFilteredData] = useState([]);

  const handleFilterClick = () => {
    const result = safeEstData
      ?.map((est) => {
        // const matches = est.buildings?.filter(
        //   (b) =>
        //     b.buildingStructure === filterKey.buildingStructure &&
        //   b.buildingStructureCode === filterKey.buildingStructureCode &&
        //   b.design === filterKey.design &&
        //   b.designCode === filterKey.designCode &&
        //   // b.buildingTypes === filterKey.buildingTypes &&
        //   // b.buildingTypesCode === filterKey.buildingTypesCode &&
        //   b.mainBuildingType === filterKey.mainBuildingType &&
        //   b.mainBuildingTypeCode === filterKey.mainBuildingTypeCode &&
        //   // b.subBuildingType === filterKey.subBuildingType &&
        //   // b.subBuildingTypeCode === filterKey.subBuildingTypeCode &&
        //   b.msNumber === filterKey.msNumber &&
        //     // Keeping the deep equality checks for load and standards
        //     isObjectEqual(b.designLoad, filterKey.designLoad) &&
        //     isObjectEqual(b.designStandards, filterKey.designStandards)
        // );
        const matches = est.buildings?.filter((b) => {
  // Helper to compare strings safely
  const compare = (val1, val2) => String(val1 || "").trim() === String(val2 || "").trim();

  return (
    compare(b.buildingStructure, filterKey.buildingStructure) &&
    compare(b.buildingStructureCode, filterKey.buildingStructureCode) &&
    compare(b.design, filterKey.design) &&
    compare(b.designCode, filterKey.designCode) &&
    // Uncommented and cleaned
    compare(b.buildingTypes, filterKey.buildingTypes) &&
    compare(b.buildingTypesCode, filterKey.buildingTypesCode) &&
    compare(b.mainBuildingType, filterKey.mainBuildingType) &&
    compare(b.mainBuildingTypeCode, filterKey.mainBuildingTypeCode) &&
    compare(b.subBuildingType, filterKey.subBuildingType) &&
    compare(b.subBuildingTypeCode, filterKey.subBuildingTypeCode) &&
    compare(b.msNumber, filterKey.msNumber) &&
    isObjectEqual(b.designLoad, filterKey.designLoad) &&
    isObjectEqual(b.designStandards, filterKey.designStandards)
  );
});

        if (matches && matches.length > 0) {
          return {
            enquiryNr: est?.enquiryNr,
            jobNr: est?.jobNr || "",
            companyName: est?.companyName || "",
            buildingStrcture: est?.buildingStrcture || "",
            buildingStrctureCode: est?.buildingStrctureCode || "",
            buildingStrctureDesc: est?.buildingStrctureDesc || "",
            transactionDate: est?.transactionDate || "",
            priority: est?.priority || "",
            timeLine: est?.timeLine || "",
            estimateStartdate: est?.estimateStartdate || "",
            estimateEndDate: est?.estimateEndDate || "",
            qtn_Job_Remarks: est?.qtn_Job_Remarks || "",
            estimationStatus: est?.estimationStatus || "",
            projectSize: est?.projectSize || "",
            remarkestimation: est?.remarkestimation || "",
            buildingName: est?.buildingName || "",
            clientName: est?.clientName || "",
            salesOfficerName: est?.salesOfficerName || "",
            Location: est?.Location || "",
            quotationNr: est?.quotationNr || "",
            buildingInputsLength: est?.buildingInputsLength || "",
            buildingInputs: est?.buildingInputs || "",
            version: est?.version || "",
            wallTypes: est?.wallTypes || "",
            design: est?.design || "",
            "designCode-1": est["designCode-1"] || "",
            designDesc: est?.designDesc || "",
            createdBy: est?.createdBy || "",
            createdName: est?.createdName || "",
            projectName: est?.projectName || "",
            location: est?.location || "",
            validUntil: est?.validUntil || "",
            estimationDate: est?.estimationDate || "",
            transactionCodeType: est?.transactionCodeType || "",
            type: est?.type || "",
            designerName: est?.designerName || "",
            checkerName: est?.checkerName || "",
            checkerNameCode: est?.checkerNameCode || "",
            checkerNameDesc: est?.checkerNameDesc || "",
            documentNumber: est?.documentNumber || "",
            typeCode: est?.typeCode || "",
            typeDesc: est?.typeDesc || "",
            typeS: est?.typeS || "",
            jobReferenceNr: est?.jobReferenceNr || "",
            qtnReferenceNr: est?.qtnReferenceNr || "",
            remarks: est?.remarks || "",
            headerStatus: est?.headerStatus || "",
            estHeaderStatus: est?.estHeaderStatus || "",
            // enquiryNr: est?.enquiryNr || "",
            transactionNr: est?.transactionNr || "",
            createdAt: est?.createdAt || "",
            updatedAt: est?.updatedAt || "",
            mainBuildingType: est?.mainBuildingType || "",
            "mainBuildingTypeCode-1": est["mainBuildingTypeCode-1"] || "",
            mainBuildingTypeDesc: est?.mainBuildingTypeDesc || "",
            buildingTypes: est?.buildingTypes || "",
            "buildingTypesCode-1": est["buildingTypesCode-1"] || "",
            buildingTypesDesc: est?.buildingTypesDesc || "",
            buildingInputsDesc: est?.buildingInputsDesc || "",
            buildingStructure: est?.buildingStructure || "",
            "buildingStructureCode-1": est["buildingStructureCode-1"] || "",
            buildingStructureDesc: est?.buildingStructureDesc || "",
            "buildingFrontInputsCode-1": est["buildingFrontInputsCode-1"] || "",
            "buildingLeftInputsCode-1": est["buildingLeftInputsCode-1"] || "",
            // getOverallBuildingArea: est?.getOverallBuildingArea || "",
            buildingCount: est?.buildingCount || "",
            additionalComponent: est?.additionalComponent || {},
            activeBuildingId: est?.activeBuildingId || "",
            canopyInputsTable: est?.canopyInputsTable || {},
            componentDataView: est?.componentDataView || {},
            draftStatus: est?.draftStatus || "",
            comonentKey: est?.comonentKey || [],
            estimationNr: est?.estimationNr || "",
            timeZone: est?.timeZone || "",
            "buildingStructureCode-2": est["buildingStructureCode-2"] || "",
            "buildingTypesCode-2": est["buildingTypesCode-2"] || "",
            "designCode-2": est["designCode-2"] || "",
            "mainBuildingTypeCode-2": est["mainBuildingTypeCode-2"] || "",
            "buildingStructureCode-3": est["buildingStructureCode-3"] || "",
            "buildingTypesCode-3": est["buildingTypesCode-3"] || "",
            "designCode-3": est["designCode-3"] || "",
            "mainBuildingTypeCode-3": est["mainBuildingTypeCode-3"] || "",
            subBuildingType: est?.subBuildingType || "",
            "subBuildingTypeCode-3": est["subBuildingTypeCode-3"] || "",
            subBuildingTypeDesc: est?.subBuildingTypeDesc || "",
            baseNumber: est?.baseNumber || "",
            "buildingStructureCode-4": est["buildingStructureCode-4"] || "",
            "designCode-4": est["designCode-4"] || "",
            "mainBuildingTypeCode-4": est["mainBuildingTypeCode-4"] || "",
            "buildingStructureCode-5": est["buildingStructureCode-5"] || "",
            "designCode-5": est["designCode-5"] || "",
            "mainBuildingTypeCode-5": est["mainBuildingTypeCode-5"] || "",
            "buildingTypesCode-4": est["buildingTypesCode-4"] || "",
            "subBuildingTypeCode-4": est["subBuildingTypeCode-4"] || "",
            businessComponentInstanceId: est?.businessComponentInstanceId || "",
            workflowActionLogs: est?.workflowActionLogs || [],
            filterCountBuildings: matches?.length || 0,
            buildings: matches,
          };
        }

        return null;
      })
      .filter(Boolean);
    setFilteredData(result);
  };


const handleSave = () => {
  if (!selectedBuilding) {
    alert("Please select a building first!");
    return;
  }

  // Ensure buildings array exists
  const currentBuildings = Array.isArray(estimationData.buildings)
    ? estimationData.buildings
    : [];

  // Update the building whose buildingId matches activeBuildingId
  const updatedBuildings = currentBuildings.map((b) =>
    b.buildingId === estimationData.activeBuildingId
      ? {
          ...b, // keep all other nested properties
          ...selectedBuilding, // copy all selected building data
          buildingId: estimationData.activeBuildingId, // update buildingId
          id: estimationData.activeBuildingId, // update id
        }
      : b
  );

  // console.log(">> updatedBuildings", updatedBuildings);

  // Dispatch updated buildings array
  dispatch(
    setEstimationData({
      ...estimationData,
      buildings: updatedBuildings,
    })
  );

  props.onHide();
};

  return (
    <Modal
      {...props}
      aria-labelledby="contained-modal-title-vcenter"
      keyboard={false}
      size="lg"
      ref={ref}
      centered
      backdrop="static"
    >
      <Modal.Header closeButton>
        <Modal.Title>Match Buildings </Modal.Title>
      </Modal.Header>

      <Modal.Body>
        
        <Row>
                    <Col xm={2} md={2} lg={2}>
                <span className="fw-medium">

            Acive Building {estimationData?.activeBuildingId}
            </span>
       
          </Col>
          <Col xm={2} md={2} lg={2} className="d-flex justify-content-center my-2">
            <button className="btnTable" onClick={handleFilterClick}>
              Fitler
            </button>
       
          </Col>

        </Row>

        {/* table  */}
        <div className="accordion" id="accordionExample">
          <div className="accordion-item">
            <h2 className="accordion-header">
              <Row className="accordion-button">
                <Col xs={1} md={1} lg={1} className="text-left arrowBtn">
                  <i
                    className={`bi ${
                      isCardVisible1 ? "bi-chevron-right" : "bi-chevron-down"
                    }`}
                    onClick={toggleCardVisibility1}
                  ></i>
                </Col>
                <Col xs={1} md={1} lg={1} className="text-center logoBtn">
                  <span className="iconLogo">EL</span>
                </Col>
                <Col xs={4} md={9} lg={6}>
                  <span className="headerTitle">Estimation List</span>
                </Col>

                <Col xs={2} md={1} lg={1} className="">
                  <div className="filter">
                    <span
                      className="icon hide headerIcon"
                      data-bs-toggle="dropdown"
                      aria-expanded="true"
                    >
                      <i className="bi bi-three-dots"></i>
                    </span>
                    <ul
                      className="dropdown-menu dropdown-menu-end dropdown-menu-arrow hide menuList"
                      data-popper-placement="bottom-end"
                    >
                      <li className="dropdown-header text-start">
                        <h6>Menu</h6>
                      </li>

                      {/* <li>
                                        <span
                                          className="dropdown-item headerIcon"
                                          onClick={handleDownloadPDF}
                                        >
                                          <i className="bi bi-download mr-2"></i>
                                          Download PDF
                                        </span>
                                      </li> */}
                    </ul>
                  </div>
                </Col>
              </Row>
            </h2>

            <div
              // id="acc"
              className={`accordion-collapse collapse show ${
                isCardVisible1 ? "visible" : ""
              }`}
              // aria-labelledby="headingOne"
              // data-bs-parent="#accordionExample"
            >
              <div className="accordion-body">
                <Row>
                  <Col xs={12} md={12} lg={12}>
                    <DataTable
                      title=""
                      columns={estimationCol}
                      data={filteredData}
                      paginationRowsPerPageOptions={Constants.ROW_PER_PAGE}
                      pagination
                      paginationServer
                      onChangeRowsPerPage={handlePerRowsChange}
                      paginationTotalRows={estimationTable.total}
                      onChangePage={handlePageChange}
                      onSelectedRowsChange={handleRowSelect}
                      // selectableRows
                    />
                  </Col>
                </Row>
              </div>
            </div>
          </div>
        </div>

        {/* building Details  */}
        <div className="accordion mt-2" id="accordionExample">
          <div className="accordion-item">
            <h2 className="accordion-header">
              <Row className="accordion-button">
                <Col xs={1} md={1} lg={1} className="text-left arrowBtn">
                  <i
                    className={`bi ${
                      isCardVisible1 ? "bi-chevron-right" : "bi-chevron-down"
                    }`}
                    onClick={toggleCardVisibility1}
                  ></i>
                </Col>
                <Col xs={1} md={1} lg={1} className="text-center logoBtn">
                  <span className="iconLogo">SB</span>
                </Col>
                <Col xs={4} md={9} lg={6}>
                  <span className="headerTitle">Selecte Buildings </span>
                </Col>

                <Col xs={2} md={1} lg={1} className="">
                  <div className="filter">
                    <span
                      className="icon hide headerIcon"
                      data-bs-toggle="dropdown"
                      aria-expanded="true"
                    >
                      <i className="bi bi-three-dots"></i>
                    </span>
                    <ul
                      className="dropdown-menu dropdown-menu-end dropdown-menu-arrow hide menuList"
                      data-popper-placement="bottom-end"
                    >
                    
                    </ul>
                  </div>
                </Col>
              </Row>
            </h2>

            <div
              // id="acc"
              className={`accordion-collapse collapse show ${
                isCardVisible1 ? "visible" : ""
              }`}
              // aria-labelledby="headingOne"
              // data-bs-parent="#accordionExample"
            >
              <div className="accordion-body">
               
                <Row>
  <div>Matching buildings</div>

  {getSelectedData?.map((data) => (
    <Col xs={12} md={12} lg={12} key={data.buildingId}>
      
      <button
        onClick={() => setSelectedBuilding(data)}
        className={
          selectedBuilding?.buildingId === data.buildingId
            ? "btn btn-primary"
            : "btn btn-outline-primary"
        }
      >
        Select Building {data.buildingId}
      </button>

    </Col>
  ))}
</Row>

              </div>
            </div>
          </div>
        </div>
      </Modal.Body>

      <Modal.Footer>
        <Button variant="secondary" onClick={() => props.onHide()}>
          Close
        </Button>
        <Button variant="secondary" onClick={handleSave}>
          save
        </Button>
      </Modal.Footer>
    </Modal>
  );
});

export default EstimationMatchModal;
